/*
 * @author bai <ghimping@alpstein.my>
 * @link https://www.alpstein.my
 * @copyright Copyright (c) Alpstein Software
 *            _____                    _____                    _____
 *           /\    \                  /\    \                  /\    \
 *          /::\    \                /::\    \                /::\    \
 *         /::::\    \              /::::\    \               \:::\    \
 *        /::::::\    \            /::::::\    \               \:::\    \
 *       /:::/\:::\    \          /:::/\:::\    \               \:::\    \
 *      /:::/__\:::\    \        /:::/__\:::\    \               \:::\    \
 *     /::::\   \:::\    \      /::::\   \:::\    \              /::::\    \
 *    /::::::\   \:::\    \    /::::::\   \:::\    \    ____    /::::::\    \
 *   /:::/\:::\   \:::\ ___\  /:::/\:::\   \:::\    \  /\   \  /:::/\:::\    \
 *  /:::/__\:::\   \:::|    |/:::/  \:::\   \:::\____\/::\   \/:::/  \:::\____\
 *  \:::\   \:::\  /:::|____|\::/    \:::\  /:::/    /\:::\  /:::/    \::/    /
 *   \:::\   \:::\/:::/    /  \/____/ \:::\/:::/    /  \:::\/:::/    / \/____/
 *    \:::\   \::::::/    /            \::::::/    /    \::::::/    /
 *     \:::\   \::::/    /              \::::/    /      \::::/____/
 *      \:::\  /:::/    /               /:::/    /        \:::\    \
 *       \:::\/:::/    /               /:::/    /          \:::\    \
 *        \::::::/    /               /:::/    /            \:::\    \
 *         \::::/    /               /:::/    /              \:::\____\
 *          \::/____/                \::/    /                \::/    /
 *           ~~                       \/____/                  \/____/
 *
 */

import React, { Component } from "react";
import PropTypes from "prop-types";
import { FormattedMessage, injectIntl } from "react-intl";
import { intl } from "../../services/intlGlobalProvider";
import { Toast, Modal } from "antd-mobile";
import { connect } from "react-redux";
import styled from "styled-components";
import * as _ from "underscore";
import Constant from "../../constants";
import CartListing from "../../components/CartListing";
import PaynowButton from "../../components/PaynowButton";
import IsFoodOnlyModal from "../../components/IsFoodOnlyModal/index";
import NotEnoughBalanceModal from "../../components/NotEnoughBalanceModal/index";
import CheckOutSection from "./CheckOutSection";
import EmptyItemSection from "./EmptyItemSection";
import LoadingIndicator from "../../components/LoadingIndicator";
import * as userAction from "../../actions/user";
import * as commonAction from "../../actions/common";
import * as selectors from "../../selectors";
import * as userSelectors from "../../selectors/user";
import * as checkoutSelector from "../../selectors/checkout";
import * as orderSelectors from "../../selectors/order";
import Theme from "../../utils/Theme";
import "./index.css";

const StyledMainContainer = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  overflow-x: hidden;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
`;

const StyledContainer = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
`;

const StyledSubtotalContainer = styled.div`
  width: 100%;
  background: white;
  border-top: 1px solid lightgray;
  box-shadow: 0 -3px 6px -5px grey;
`;

const StyledSubtotalContentContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  font-size: 0.9em;
  color: grey;
  padding: 8px 15px;
`;

const StyledInfoContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-end;
  font-size: 1em;
`;

const StyledSubTotal = styled.span`
  margin-left: 5px;
  font-weight: bold;
  color: ${Theme.TertiaryColor};
  font-size: 1.2em;
`;

const Alert = Modal.alert;

const Prompt = Modal.prompt;

function closest(el, selector) {
  const matchesSelector =
    el.matches ||
    el.webkitMatchesSelector ||
    el.mozMatchesSelector ||
    el.msMatchesSelector;
  while (el) {
    if (matchesSelector.call(el, selector)) {
      return el;
    }
    el = el.parentElement;
  }
  return null;
}

class CartPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isFoodOnlyModal: false,
      notEnoughBalanceModal: false,
      dialogInfo: ""
    };
  }

  componentDidMount() {
    const { userCartItem, authToken } = this.props;
    let cartItemLength = 0;

    if (userCartItem) {
      cartItemLength = userSelectors.getUserCartItemQuantityTotal(userCartItem);
    }

    this.fetchDeliveryEnabledData();
    this.configureNavBar(cartItemLength);
    if (authToken) {
      this.fetchUserCartItemData();
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.checkoutStatus !== this.props.checkoutStatus) {
      if (nextProps.checkoutStatus) {
        const { checkoutData } = nextProps;
        const orderID = orderSelectors.getOrderID(checkoutData);

        this.props.history.push(`/shop/order/${orderID}`);
      }
    }

    if (nextProps.errorType !== this.props.errorType) {
      if (nextProps.errorType) {
        this.setState({ notEnoughBalanceModal: true });
      }
    }

    if (this.props.userCartItem !== nextProps.userCartItem) {
      const cartItemLength = userSelectors.getUserCartItemQuantityTotal(
        nextProps.userCartItem
      );

      this.configureNavBar(cartItemLength);
      if (
        this.props.location &&
        this.props.location.state &&
        this.props.location.state.qrcodeValue &&
        !_.isEmpty(this.props.location.state.qrcodeValue)
      ) {
        const currentTableCode = userSelectors.getUserCartItemTableCode(
          nextProps.userCartItem
        );

        /** To avoid call api when user input is same as previous input **/
        if (currentTableCode === this.props.location.state.qrcodeValue) {
          return;
        }

        this.onTableLocationSubmit(this.props.location.state.qrcodeValue);
      }
    }

    if (nextProps.authToken !== this.props.authToken) {
      if (nextProps.authToken) {
        this.fetchUserCartItemData();
      }
    }
  }

  configureNavBar = (qty = 0) => {
    const { navbarConfig, showTabbar, showNavbar } = this.props;

    navbarConfig(
      <FormattedMessage
        id="cart.title"
        defaultMessage="Cart (0)"
        description="Cart page title"
        values={{
          cartItem: qty
        }}
      />,
      <div />
    );
    showNavbar(true);
    showTabbar(true);
  };

  fetchDeliveryEnabledData = () => {
    const { getDeliveryEnabledRequest } = this.props;

    getDeliveryEnabledRequest && getDeliveryEnabledRequest();
  };

  fetchUserCartItemData = () => {
    const { getUserCartItemRequest } = this.props;

    getUserCartItemRequest && getUserCartItemRequest();
  };

  getLoadingIndicator = () => {
    const {
      userCartLoading,
      deleteCartLoading,
      updateDeliveryLoading,
      checkoutLoading,
      applyUserCartPointLoading,
      applyUserCartWalletLoading,
      updateTableLoading
    } = this.props;

    if (
      userCartLoading ||
      deleteCartLoading ||
      updateDeliveryLoading ||
      checkoutLoading ||
      applyUserCartPointLoading ||
      applyUserCartWalletLoading ||
      updateTableLoading
    ) {
      return <LoadingIndicator />;
    }

    return null;
  };

  showConfirmDeleteFoodDialog = cartFoodId => {
    Alert(
      intl.formatMessage({
        id: "cart.order.item.delete.food.title"
      }),
      intl.formatMessage({
        id: "cart.order.item.delete.food.description"
      }),
      [
        {
          text: intl.formatMessage({
            id: "app.cancel",
            defaultMessage: "Cancel"
          })
        },
        {
          text: intl.formatMessage({
            id: "app.ok",
            defaultMessage: "OK"
          }),
          onPress: () => {
            this.onDeleteFoodFromCart(cartFoodId);
          }
        }
      ]
    );
  };

  promptUseEPointDialog = (usablePointDisplay, usablePoint) => {
    const { applyUserCartPointRequest } = this.props;

    Prompt(
      intl.formatMessage({ id: "cart.order.payment.point.title" }),
      intl.formatMessage(
        { id: "cart.order.payment.point.description" },
        { Amount: usablePointDisplay }
      ),
      [
        {
          text: intl.formatMessage({
            id: "app.cancel",
            defaultMessage: "Cancel"
          })
        },
        {
          text: intl.formatMessage({
            id: "app.ok",
            defaultMessage: "OK"
          }),
          onPress: amount =>
            applyUserCartPointRequest &&
            applyUserCartPointRequest({ amount: amount })
        }
      ],
      "default",
      usablePoint
    );
  };

  promptUseEBalanceDialog = (usableBalanceDisplay, usableBalance) => {
    const { applyUserCartWalletRequest } = this.props;

    Prompt(
      intl.formatMessage({ id: "cart.order.payment.wallet.title" }),
      intl.formatMessage(
        { id: "cart.order.payment.wallet.description" },
        { Amount: usableBalanceDisplay }
      ),
      [
        {
          text: intl.formatMessage({
            id: "app.cancel",
            defaultMessage: "Cancel"
          })
        },
        {
          text: intl.formatMessage({
            id: "app.ok",
            defaultMessage: "OK"
          }),
          onPress: amount =>
            applyUserCartWalletRequest &&
            applyUserCartWalletRequest({ amount: amount })
        }
      ],
      "default",
      usableBalance
    );
  };

  onWrapTouchStart = e => {
    if (!/iPhone|iPod|iPad/i.test(navigator.userAgent)) {
      return;
    }
    const pNode = closest(e.target, ".am-modal-content");
    if (!pNode) {
      e.preventDefault();
    }
  };

  showCheckoutAlert = () => {
    Alert(
      intl.formatMessage({
        id: "cart.order.item.checkout.food.title"
      }),
      intl.formatMessage({
        id: "cart.order.item.checkout.food.description"
      }),
      [
        {
          text: intl.formatMessage({
            id: "app.cancel",
            defaultMessage: "Cancel"
          })
        },
        {
          text: intl.formatMessage({
            id: "app.ok",
            defaultMessage: "OK"
          }),
          onPress: () => {
            this.onCheckoutFromCart();
          }
        }
      ]
    );
  };

  showIsFoodOnlyModal = e => {
    e.preventDefault();
    this.setState({
      isFoodOnlyModal: true
    });
  };

  showNotEnoughBalanceModal = () => {
    this.setState({
      notEnoughBalanceModal: true
    });
  };

  onCheckoutPressed = e => {
    const { getIsFoodOnly } = this.props;
    if (getIsFoodOnly) {
      this.showIsFoodOnlyModal(e);
    } else {
      this.showCheckoutAlert();
    }
  };

  onIsFoodOnlyModalClose = () => {
    this.setState({ isFoodOnlyModal: false });
  };

  onNotEnoughBalanceModalClose = () => {
    this.setState({ notEnoughBalanceModal: false });
  };

  onPressDeliver = (cartFoodId, isDelivery) => {
    const { updateUserCartFoodDeliveryRequest } = this.props;

    updateUserCartFoodDeliveryRequest &&
      updateUserCartFoodDeliveryRequest(cartFoodId, !isDelivery);
  };

  onPressEditFood = cartFoodId => {
    const { history } = this.props;

    history.push(`/shop/cart/${cartFoodId}`);
  };

  onDeleteFoodFromCart = cartFoodId => {
    const { deleteUserCartItemRequest } = this.props;

    deleteUserCartItemRequest && deleteUserCartItemRequest(cartFoodId);
  };

  onTableLocationSubmit = tableNo => {
    const { updateUserOrderTableRequest, userCartItem } = this.props;

    const currentTableCode = userSelectors.getUserCartItemTableCode(
      userCartItem
    );

    /** To avoid call api when user input is same as previous input **/
    if (currentTableCode === tableNo) {
      return;
    }

    let submitData = {
      code: tableNo
    };
    updateUserOrderTableRequest(submitData);
  };

  onPressClearPoint = () => {
    const { applyUserCartPointRequest } = this.props;
    let submitData = {
      amount: 0
    };
    applyUserCartPointRequest(submitData);
  };

  onPressClearBalance = () => {
    const { applyUserCartWalletRequest } = this.props;
    let submitData = {
      amount: 0
    };
    applyUserCartWalletRequest(submitData);
  };

  onCheckoutFromCart = () => {
    this.setState({ isFoodOnlyModal: false });
    const { userCartItem, checkoutUserCartRequest } = this.props;

    const token = userSelectors.getUserCartItemToken(userCartItem);
    let submitData = {
      token: token,
      gateway_code: Constant.iPay88
    };
    checkoutUserCartRequest(submitData);
  };

  onRedirectTopUp = () => {
    const { history } = this.props;
    this.setState({ notEnoughBalance: false });
    history.push("/shop/top-up");
  };

  onCheckoutDialog = () => {
    const { notEnoughBalanceModal } = this.state;
    const { userCartItem } = this.props;

    const cartWallet = userSelectors.getUserCartItemCheckoutWallet(
      userCartItem
    );
    const walletBalance = checkoutSelector.getWalletBalance(cartWallet);
    const cartPoint = userSelectors.getUserCartItemCheckoutPoint(userCartItem);
    const pointBalance = checkoutSelector.getPointBalance(cartPoint);
    const walletIsApplied = userSelectors.getUserCartWalletIsApplied(
      userCartItem
    );
    const pointIsApplied = userSelectors.getUserCartPointIsApplied(
      userCartItem
    );
    const paymentBalance = userSelectors.getUserCartPaymentBalance(
      userCartItem
    );

    if (
      walletIsApplied ||
      pointIsApplied ||
      walletBalance === 0 ||
      pointBalance === 0
    ) {
      if (paymentBalance !== 0) {
        return (
          <NotEnoughBalanceModal
            shouldShow={notEnoughBalanceModal}
            title={"notenough.title"}
            image={require("../../assets/icons/no_wallet.png")}
            content={"notenough.content"}
            button={true}
            buttonContent={"notenough.no"}
            onTouchStart={this.onWrapTouchStart}
            onRedirectTopUp={this.onRedirectTopUp}
            onNotEnoughBalanceModalClose={this.onNotEnoughBalanceModalClose}
          />
        );
      }
    } else {
      return (
        <NotEnoughBalanceModal
          shouldShow={notEnoughBalanceModal}
          title={"notenough.choose.payment.title"}
          image={require("../../assets/icons/add_wallet.png")}
          content={"notenough.choose.payment.content"}
          button={false}
          buttonContent={"notenough.choose.payment.no"}
          onTouchStart={this.onWrapTouchStart}
          onRedirectTopUp={this.onRedirectTopUp}
          onNotEnoughBalanceModalClose={this.onNotEnoughBalanceModalClose}
        />
      );
    }
  };

  render() {
    const { isFoodOnlyModal } = this.state;
    const { userCartItem, deliveryEnabled } = this.props;
    const stallCartItems = userSelectors.getUserCartItemStall(userCartItem);
    const stallCartCurrency = userSelectors.getUserCartItemCurrencySymbol(
      userCartItem
    );
    const currentTableCode = userSelectors.getUserCartItemTableCode(
      userCartItem
    );
    const earnPoints = userSelectors.getUserCartItemStallTotalPoint(
      userCartItem
    );
    const cartSummary = userSelectors.getUserCartItemCheckoutSummaryItem(
      userCartItem
    );
    const cartWallet = userSelectors.getUserCartItemCheckoutWallet(
      userCartItem
    );
    const cartPoint = userSelectors.getUserCartItemCheckoutPoint(userCartItem);
    const cartPayment = userSelectors.getUserCartItemCheckoutPayment(
      userCartItem
    );
    const paymentTotal = checkoutSelector.getPaymentTotal(cartPayment);
    const paymentBalanceTotal = checkoutSelector.getPaymentBalance(cartPayment);

    return (
      <StyledMainContainer>
        {this.getLoadingIndicator()}
        {stallCartItems && stallCartItems.length > 0 ? (
          <StyledContainer>
            <CartListing
              {...this.props}
              currency={stallCartCurrency}
              items={stallCartItems}
              renderHeader={null}
              renderFooter={() => (
                <CheckOutSection
                  cartSummary={cartSummary}
                  currency={stallCartCurrency}
                  currentTable={currentTableCode}
                  currentPoint={cartPoint}
                  currentWallet={cartWallet}
                  earnPoints={earnPoints}
                  paymentTotal={paymentTotal}
                  deliveryEnabled={deliveryEnabled}
                  onTableValueSubmit={this.onTableLocationSubmit}
                  onPressUseEOrder={this.promptUseEPointDialog}
                  onPressUseEWallet={this.promptUseEBalanceDialog}
                  onPressClearPoint={this.onPressClearPoint}
                  onPressClearBalance={this.onPressClearBalance}
                  {...this.props}
                />
              )}
              onDeliveryPressed={this.onPressDeliver}
              onEditItem={this.onPressEditFood}
              onDeleteItem={this.showConfirmDeleteFoodDialog}
            />
            <StyledSubtotalContainer>
              <StyledSubtotalContentContainer>
                <StyledInfoContainer>
                  <span>
                    <FormattedMessage
                      id="cart.subtotal.title"
                      defaultMessage="Subtotal: "
                      description="Subtotal Text"
                    />
                  </span>
                  <StyledSubTotal>
                    {stallCartCurrency} {paymentBalanceTotal}
                  </StyledSubTotal>
                </StyledInfoContainer>
                <PaynowButton
                  onClicked={e => this.onCheckoutPressed(e)}
                  active={true}
                />
              </StyledSubtotalContentContainer>
            </StyledSubtotalContainer>
            <IsFoodOnlyModal
              shouldShow={isFoodOnlyModal}
              onTouchStart={this.onWrapTouchStart}
              onCheckoutFromCart={this.onCheckoutFromCart}
              onIsFoodOnlyModalClose={this.onIsFoodOnlyModalClose}
            />
            {this.onCheckoutDialog()}
          </StyledContainer>
        ) : (
          <EmptyItemSection {...this.props} />
        )}
      </StyledMainContainer>
    );
  }
}

CartPage.propTypes = {
  intl: PropTypes.object,
  showNavbar: PropTypes.func.isRequired,
  showTabbar: PropTypes.func.isRequired,
  navbarConfig: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  userCartLoading: PropTypes.bool,
  userCartItem: PropTypes.array,
  applyUserCartPointLoading: PropTypes.bool,
  applyUserCartWalletLoading: PropTypes.bool,
  deleteCartLoading: PropTypes.bool,
  deleteCartStatus: PropTypes.bool,
  applyUserCartStatus: PropTypes.bool,
  requestCartStatus: PropTypes.bool,
  editCartStatus: PropTypes.bool,
  updateDeliveryLoading: PropTypes.bool,
  updateCartLoading: PropTypes.bool,
  checkoutLoading: PropTypes.bool,
  checkoutStatus: PropTypes.bool,
  checkoutData: PropTypes.object,
  authToken: PropTypes.string,
  updateTableLoading: PropTypes.bool,
  getUserCartItemRequest: PropTypes.func,
  deleteUserCartItemRequest: PropTypes.func,
  updateUserCartFoodDeliveryRequest: PropTypes.func,
  checkoutUserCartRequest: PropTypes.func,
  applyUserCartPointRequest: PropTypes.func,
  applyUserCartWalletRequest: PropTypes.func,
  updateUserOrderTableRequest: PropTypes.func,
  getDeliveryEnabledRequest: PropTypes.func,
  getIsFoodOnly: PropTypes.string,
  deliveryEnabled: PropTypes.bool,
  errorType: PropTypes.bool
};

function mapStateToProps(state) {
  return {
    userCartLoading: selectors.getUserCartLoading(state),
    userCartItem: selectors.getUserCartItem(state),
    applyUserCartPointLoading: selectors.getApplyUserCartPointLoading(state),
    applyUserCartWalletLoading: selectors.getApplyUserCartWalletLoading(state),
    deleteCartLoading: selectors.getDeleteUserCartLoading(state),
    deleteCartStatus: selectors.getDeleteUserCartStatus(state),
    applyUserCartStatus: selectors.getApplyUserCartWalletStatus(state),
    requestCartStatus: selectors.getRequestCartFoodStatus(state),
    editCartStatus: selectors.getUpdateCartFoodStatus(state),
    updateDeliveryLoading: selectors.getUpdateCartFoodLoading(state),
    updateCartLoading: selectors.getUpdateCartFoodLoading(state),
    checkoutLoading: selectors.getUserCheckoutLoading(state),
    checkoutStatus: selectors.getUserCheckoutStatus(state),
    checkoutData: selectors.getUserCheckoutItem(state),
    authToken: selectors.getAuthToken(state),
    updateTableLoading: selectors.getUpdateUserCartTableLoading(state),
    getIsFoodOnly: selectors.getIsFoodOnlyStatus(state),
    deliveryEnabled: selectors.getDeliveryEnabledData(state),
    errorType: selectors.getErrorType(state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getUserCartItemRequest: () => dispatch(userAction.getUserCartItemRequest()),
    getDeliveryEnabledRequest: () =>
      dispatch(commonAction.getDeliveryEnabledRequest()),
    deleteUserCartItemRequest: cartID =>
      dispatch(userAction.deleteUserCartItemRequest(cartID)),
    updateUserCartFoodDeliveryRequest: (cartID, deliveryStatus) =>
      dispatch(
        userAction.updateUserCartFoodDeliveryRequest(cartID, deliveryStatus)
      ),
    checkoutUserCartRequest: checkoutData =>
      dispatch(userAction.checkoutUserCartRequest(checkoutData)),
    applyUserCartPointRequest: pointData =>
      dispatch(userAction.applyUserCartPointRequest(pointData)),
    applyUserCartWalletRequest: walletData =>
      dispatch(userAction.applyUserCartWalletRequest(walletData)),
    updateUserOrderTableRequest: tableData =>
      dispatch(userAction.updateUserOrderTableRequest(tableData))
  };
}

export default injectIntl(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(CartPage)
);



// WEBPACK FOOTER //
// ./src/containers/CartPage/index.js